
import { computed, defineComponent, PropType } from 'vue'
import { PatientListingType } from '@/shared/types'
import { EPatientCard } from '@/entities/EPatientCard'
import { useRouter, useRoute } from 'vue-router'
import { declination } from '@/shared/utils'

export default defineComponent({
  name: 'PatientListing',

  components: { EPatientCard },

  props: {
    patientList: Object as PropType<PatientListingType>,
  },

  setup(props) {
    const router = useRouter()
    const route = useRoute()

    const activePatientId = computed(() =>
      route.params.patientId === 'null-patient'
        ? 0
        : Number(route.params.patientId)
    )

    const signature = computed(() =>
      declination(props.patientList.withoutPatientCount, [
        'отчет',
        'отчета',
        'отчетов',
      ])
    )

    const handleChoosePatient = (patientId: number): void => {
      router.push(`/patient/${patientId ? patientId : 'null-patient'}`)
    }

    return {
      activePatientId,
      signature,
      handleChoosePatient,
    }
  },
})
